var _style, _path, _path2, _path3, _path4, _path5, _path6, _defs, _path7, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYolorektLogoStacked3D(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 474 266.5",
    style: {
      enableBackground: "new 0 0 474 266.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000047052483136481991610000006442682933938376086_);}\n\t.st2{fill:url(#SVGID_00000091000430870185938790000005938084603192860338_);}\n\t.st3{fill:url(#SVGID_00000124882449800982777220000002101463069567538313_);}\n\t.st4{fill:url(#SVGID_00000050639775091234324420000005235822965424521660_);}\n\t.st5{fill:url(#SVGID_00000096045767958206529490000013266085285211333531_);}\n\t.st6{fill:url(#SVGID_00000044865932847036505990000007380470292067469449_);}\n\t.st7{fill:url(#SVGID_00000042705905677139969160000014110720687458361506_);}\n\t.st8{fill:url(#SVGID_00000002377387655299472310000004061628724878604423_);}\n\t.st9{fill:#FFFAE6;}\n\t.st10{fill:url(#SVGID_00000021083797102081846070000001516878599339563163_);}\n\t.st11{fill:url(#SVGID_00000066517212363835887640000010236637110311530131_);}\n\t.st12{fill:url(#SVGID_00000151533546085558309280000017103795231156931757_);}\n\t.st13{fill:url(#SVGID_00000103252251915166581510000013580931871010673045_);}\n\t.st14{clip-path:url(#SVGID_00000003072001238997861130000009910461482052731817_);}\n\t.st15{fill:url(#SVGID_00000070837924307606636140000015842099861754312071_);}\n\t.st16{fill:url(#SVGID_00000112620291215065565470000016957421752498639795_);}\n\t.st17{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 233.1134,
    cy: 570.1131,
    r: 80.7209,
    gradientTransform: "matrix(1 0 0 1 0 -495.2643)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1152DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3227,
    style: {
      stopColor: "#1152DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6649,
    style: {
      stopColor: "#1050D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1050D8"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M314.4,77.5c0,42.8-34.7,77.5-77.5,77.5s-77.5-34.7-77.5-77.5S194.1,0,236.9,0S314.4,34.7,314.4,77.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152942372046870103200000003558236409519299969_",
    gradientUnits: "userSpaceOnUse",
    x1: 236.9,
    y1: 543.8807,
    x2: 236.9,
    y2: 682.4112,
    gradientTransform: "matrix(1 0 0 1 0 -478.6079)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3759A0",
      stopOpacity: 0.04
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4671,
    style: {
      stopColor: "#0E45BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8016,
    style: {
      stopColor: "#305194"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C63B5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000152942372046870103200000003558236409519299969_)"
    },
    d: "M159.4,77.5c0,27.7,14.5,51.9,36.3,65.7 h82.4c21.8-13.7,36.3-38,36.3-65.7s-14.5-51.9-36.3-65.7h-82.4C173.9,25.6,159.4,49.9,159.4,77.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000064352355171915126970000008010852572786757304_",
    gradientUnits: "userSpaceOnUse",
    x1: 236.9,
    y1: 574.8885,
    x2: 236.9,
    y2: 434.8977,
    gradientTransform: "matrix(1 0 0 1 0 -478.6079)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3759A0",
      stopOpacity: 0.04
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4671,
    style: {
      stopColor: "#0E45BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8016,
    style: {
      stopColor: "#305194"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C63B5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000064352355171915126970000008010852572786757304_)"
    },
    d: "M159.4,77.5c0,19.7,7.4,37.8,19.5,51.4 h116c12.1-13.7,19.5-31.7,19.5-51.4s-7.4-37.8-19.5-51.4h-116C166.7,39.8,159.4,57.8,159.4,77.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000046310518446301631630000003676386718917458089_",
    gradientUnits: "userSpaceOnUse",
    x1: 236.9,
    y1: 558.4726,
    x2: 236.9,
    y2: 603.2438,
    gradientTransform: "matrix(1 0 0 1 0 -478.6079)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3759A0",
      stopOpacity: 0.04
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4671,
    style: {
      stopColor: "#0E45BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8016,
    style: {
      stopColor: "#305194"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C63B5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000046310518446301631630000003676386718917458089_)"
    },
    d: "M159.4,77.5c0,11.5,2.5,22.5,7,32.3h141 c4.5-9.8,7-20.8,7-32.3s-2.5-22.5-7-32.3h-141C161.9,55,159.4,66,159.4,77.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044175100177070048180000015055564570395730844_",
    gradientUnits: "userSpaceOnUse",
    x1: 236.9,
    y1: 573.0645,
    x2: 236.9,
    y2: 496.8259,
    gradientTransform: "matrix(1 0 0 1 0 -478.6079)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3759A0",
      stopOpacity: 0.04
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4671,
    style: {
      stopColor: "#0E45BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8016,
    style: {
      stopColor: "#305194"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C63B5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000044175100177070048180000015055564570395730844_)"
    },
    d: "M159.4,77.5c0,6.7,0.8,13.2,2.4,19.3H312 c1.6-6.2,2.4-12.7,2.4-19.3s-0.8-13.2-2.4-19.3H161.8C160.2,64.4,159.4,70.8,159.4,77.5z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000084532193894570047220000010935340153191389334_",
    cx: 208.0336,
    cy: 551.8733,
    r: 108.5277,
    gradientTransform: "matrix(1 0 0 1 0 -495.2643)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3571F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2837,
    style: {
      stopColor: "#2767EF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5391,
    style: {
      stopColor: "#2062EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7827,
    style: {
      stopColor: "#195DEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#175CEE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000084532193894570047220000010935340153191389334_)"
    },
    d: "M230.7,0.2 c-39.9,3.2-71.3,36.6-71.3,77.3s31.4,74.1,71.4,77.3c39.9-3.1,71.4-36.5,71.4-77.3S270.7,3.4,230.7,0.2z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000087379937031533202100000003091242099497555130_",
    cx: 230.7,
    cy: 572.7643,
    r: 67.9017,
    gradientTransform: "matrix(1 0 0 1 0 -495.2643)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFCF8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9485,
    style: {
      stopColor: "#FFFCF8",
      stopOpacity: 0.05098
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFCF8",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000087379937031533202100000003091242099497555130_)"
    },
    d: "M234.7,7.3c-2.7-0.4-5.4-0.4-8,0 c-34.6,4.7-61.2,34.3-61.2,70.2s26.6,65.5,61.2,70.2c2.7,0.4,5.4,0.4,8,0c34.6-4.7,61.2-34.3,61.2-70.2S269.3,12,234.7,7.3z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000049940871794340080230000010204095119822953874_",
    cx: 266.8374,
    cy: 562.4378,
    r: 97.9876,
    gradientTransform: "matrix(0.9201 0 0 1.0039 -9.2111 -495.1652)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1154E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3227,
    style: {
      stopColor: "#1154E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6649,
    style: {
      stopColor: "#1155E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1155E3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049940871794340080230000010204095119822953874_)"
    },
    d: "M288,77.5c0-34.7-25.8-62.9-57.6-62.9 s-57.6,28.1-57.6,62.9s25.8,62.9,57.6,62.9S288,112.2,288,77.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145778418231591822060000005844997923951793809_",
    gradientUnits: "userSpaceOnUse",
    x1: 278.3059,
    y1: 612.7212,
    x2: 192.1158,
    y2: 539.6794,
    gradientTransform: "matrix(1 0 0 0.9901 0 -492.9036)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002257436,
    style: {
      stopColor: "#244DA3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4631,
    style: {
      stopColor: "#2365EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#628DF0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145778418231591822060000005844997923951793809_)"
    },
    d: "M246.2,17.1c-7.2-2.2-14.8-2.2-22,0 c-24.1,7.5-41.8,31.7-41.8,60.5c0,29.3,18.4,53.9,43.2,60.9c6.3,1.8,12.9,1.8,19.2,0c24.9-7,43.2-31.6,43.2-60.9 C288,48.8,270.3,24.6,246.2,17.1z"
  }), /*#__PURE__*/React.createElement("g", null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M255.5,40.2c-12.4,0.3-22.4,11.5-22.4,24.3s9.9,23.8,22.4,24.3c12.4,0,22.4-11.5,22.4-24.3 S267.9,40.6,255.5,40.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000168093670842026444110000000007076487445911950_",
    cx: 289.1828,
    cy: 555.6006,
    r: 23.0361,
    gradientTransform: "matrix(0.9201 0 0 1.0039 -9.2111 -495.1652)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1154E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1154E1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000168093670842026444110000000007076487445911950_)"
    },
    d: "M269,64.5c0-8.2-6.1-14.8-13.5-14.8 c-7.5,0-13.5,6.6-13.5,14.8s6.1,14.8,13.5,14.8C263,79.3,269,72.7,269,64.5z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000101096177338085031110000010113236254833090951_",
    cx: 591.3768,
    cy: 554.7098,
    r: 21.5496,
    fx: 611.5015,
    fy: 547.0041,
    gradientTransform: "matrix(0.8799 0 0 1 -266.8241 -495.2643)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#427AF1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFA700"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000101096177338085031110000010113236254833090951_)"
    },
    d: "M260.1,50.6c-1.5-0.5-2.8-0.9-4.3-0.3 c-5,1.8-8.6,7.5-8.6,14.2c0,6.9,3.8,12.7,8.9,14.3c1.3,0.4,2.9-0.2,4.2-0.6c4.2-1.9,8.7-6.9,8.7-13.7 C269,57.7,265.1,52.4,260.1,50.6z"
  }))), /*#__PURE__*/React.createElement("g", null, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M238.5,96.9c-6.6,0-12,5.8-12,12.7s5.3,12.6,12,12.6c6.7-0.2,12-5.8,12-12.6S245.1,97.1,238.5,96.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000088833926808712329920000011052267330839751591_",
    cx: 658.2067,
    cy: 760.9946,
    r: 8.3529,
    gradientTransform: "matrix(0.8612 0 0 0.9397 -327.8647 -606.223)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1155E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1155E3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000088833926808712329920000011052267330839751591_)"
    },
    d: "M243.1,109.5c0-2.8-2.1-5-4.6-5 s-4.6,2.2-4.6,5s2.1,5,4.6,5S243.1,112.3,243.1,109.5z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000119805736532771802600000003719274622645548169_",
    cx: 2268.979,
    cy: 824.0358,
    r: 7.8116,
    fx: 2276.2742,
    fy: 821.2425,
    gradientTransform: "matrix(0.6672 0 0 0.9136 -1274.9489 -644.9792)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#427AF1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFA700"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000119805736532771802600000003719274622645548169_)"
    },
    d: "M240.3,104.9c-0.4-0.2-0.4-0.3-0.8-0.1 c-1.4,0.6-2.4,2.5-2.4,4.7c0,2.3,1,4.2,2.5,4.7c0.4,0.1,0.8-0.2,1.2-0.4c1-0.6,2.3-2.1,2.3-4.4 C243.1,107.3,241.7,105.5,240.3,104.9z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M221,57c-2.8,0-5.2,2.5-5.2,5.4s2.3,5.4,5.2,5.4c3,0,5.2-2.4,5.2-5.4S223.8,57,221,57z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M203.8,96.1c-2.8,0-5.2,2.5-5.2,5.4s2.3,5.4,5.2,5.4c3,0,5.2-2.4,5.2-5.4S206.6,96.1,203.8,96.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M266.1,103.2c-2.8,0-5.2,2.5-5.2,5.4s2.3,5.4,5.2,5.4c3,0,5.2-2.4,5.2-5.4S268.9,103.2,266.1,103.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000014609763237350074920000006937728847994627489_",
    d: "M246.2,17c-7.2-2.2-14.8-2.2-22,0 c-24.1,7.5-41.8,31.7-41.8,60.5c0,29.3,18.4,53.9,43.2,60.9c6.3,1.8,12.9,1.8,19.2,0c24.9-7,43.2-31.6,43.2-60.9 C288,48.8,270.3,24.5,246.2,17z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000028285987980415637130000003995263526118526897_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000014609763237350074920000006937728847994627489_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000028285987980415637130000003995263526118526897_)"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M202.2,27.9c-6.6,0-12,5.8-12,12.7s5.3,12.6,12,12.6c6.7-0.2,12-5.8,12-12.6S208.8,28.1,202.2,27.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000002357746942600330100000001390246324201561738_",
    cx: 616.0112,
    cy: 687.5986,
    r: 8.3529,
    gradientTransform: "matrix(0.8612 0 0 0.9397 -327.8647 -606.223)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1155E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1155E3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000002357746942600330100000001390246324201561738_)"
    },
    d: "M206.8,40.6c0-2.8-2.1-5-4.6-5 s-4.6,2.2-4.6,5c0,2.8,2.1,5,4.6,5C204.7,45.6,206.8,43.3,206.8,40.6z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000139274823132043596530000007075037519289485992_",
    cx: 2214.5125,
    cy: 748.5475,
    r: 7.8116,
    fx: 2221.8076,
    fy: 745.7543,
    gradientTransform: "matrix(0.6672 0 0 0.9136 -1274.9489 -644.9792)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#427AF1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFA700"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000139274823132043596530000007075037519289485992_)"
    },
    d: "M204,36c-0.4-0.2-0.4-0.3-0.8-0.1 c-1.4,0.6-2.4,2.5-2.4,4.7c0,2.3,1,4.2,2.5,4.7c0.4,0.1,0.8-0.2,1.2-0.4c1-0.6,2.3-2.1,2.3-4.4C206.8,38.3,205.3,36.5,204,36z "
  })))))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M294.3,196.5C294.3,196.5,294.1,196.2,294.3,196.5C294.2,196.4,294.2,195.8,294.3,196.5L294.3,196.5 c-3-3.1-6.2-4.4-10.3-4.4c-4.2,0-7.8,1.5-10.7,4.5c-3,3-4.4,6.6-4.4,10.7v25.2c0,2.8-1,5.2-3,7.1s-4.3,2.9-7.1,2.9 c-2.8,0-5.2-1-7.1-2.9s-2.9-4.3-2.9-7.1v-25.9c0.3-9.4,3.8-17.5,10.3-24.1c6.6-6.7,14.9-10.1,24.8-10.3c5.7,0.1,10.9,1.4,15.5,3.7 c3.4,1.7,4.2,2.3,4.2,2.3l0,0C295.1,186.9,294.3,196.5,294.3,196.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M155.8,159.4c2.7,0,5,1,7,3s3,4.3,3,7v62.3c0,2.8-1,5.1-3,7s-4.3,2.8-7,2.8c-2.8,0-5.1-0.9-7-2.8 s-2.8-4.2-2.8-7v-62.3c0-2.7,0.9-5,2.8-7C150.7,160.4,153,159.4,155.8,159.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M41.4,215.5c2.6,0,4.9,0.9,6.9,2.8c2,1.9,3,4.2,3,7c0,2.7-1,5-2.9,6.9s-4.2,2.9-6.9,3 c-9.8-0.2-24.7-3.5-31.2-10.2c-6.6-6.6-10-14.6-10.3-24v-19.4c0-2.8,0.9-5.1,2.8-7s4.2-2.8,7-2.8c2.7,0,5,0.9,7,2.8 c2,1.9,3,4.2,3,7v18.7c0,4.1,1.5,7.6,4.4,10.6C27,214,37.3,215.5,41.4,215.5z M29.2,266.5c-2.7-0.1-5-1.1-6.9-3s-2.9-4.2-2.9-6.9 c0-2.8,1-5.1,2.9-7c2-1.9,4.3-2.8,6.9-2.8c4.2,0,7.7-1.5,10.6-4.5s4.4-6.5,4.4-10.6v-50c0-2.8,0.9-5.1,2.8-7s4.2-2.8,7-2.8 c2.7,0,5,0.9,7,2.8c2,1.9,3,4.2,3,7v50.8c-0.3,9.3-3.7,17.2-10.3,23.8S39,266.4,29.2,266.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M104.6,171.5c9.9,0.2,18.2,3.7,24.8,10.4c6.6,6.7,10.1,15,10.4,24.9c-0.3,9.9-3.8,18.2-10.4,24.9 c-6.6,6.7-14.9,10.1-24.8,10.4c-10-0.2-18.3-3.7-24.9-10.4s-10.1-15-10.4-24.9c0.3-9.9,3.8-18.2,10.4-24.9 C86.3,175.2,94.6,171.7,104.6,171.5z M119.7,206.7c0-4.1-1.5-7.7-4.5-10.7s-6.5-4.5-10.7-4.5s-7.8,1.5-10.8,4.5s-4.5,6.6-4.5,10.7 s1.5,7.7,4.5,10.7s6.6,4.5,10.8,4.5c4.1,0,7.7-1.5,10.7-4.5S119.7,210.8,119.7,206.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M374.8,159.5c2.7,0,5,1,7,3s3,4.3,3,7v62.3c0,2.8-1,5.1-3,7c-2,1.9-4.3,2.8-7,2.8c-2.8,0-5.1-0.9-7-2.8 s-2.8-4.2-2.8-7v-62.3c0-2.7,0.9-5,2.8-7C369.7,160.5,372.1,159.5,374.8,159.5z M423,181.7c-0.2,9.6-3.7,17.9-10.6,24.9 c6.9,7,10.5,15.4,10.6,25c0,2.8-0.9,5.1-2.8,7c-1.9,1.9-4.2,2.8-7,2.8c-2.7,0-5-0.9-7-2.8s-3-4.2-3-7c0-4.1-1.5-7.6-4.4-10.6 s-11.3-4.5-15.4-4.5c-2.6,0-4.9-0.9-6.9-2.8s-3-4.2-3-7c0-2.9,1-5.2,3-7.1s4.3-2.8,6.9-2.8c4.2,0,12.5-1.5,15.4-4.5 s4.4-6.5,4.4-10.6c0-2.8,1-5.1,3-7s4.3-2.8,7-2.8c2.8,0,5.1,0.9,7,2.8C422.1,176.6,423,178.9,423,181.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M464,221.8c2.6,0,4.9,0.9,6.9,2.8c2,1.9,3,4.2,3,7c0,2.7-1,5-2.9,6.9s-4.2,2.9-6.9,3 c-9.8-0.2-18-3.5-24.5-10.2c-6.6-6.6-10-14.6-10.3-24v-38.1c0-2.8,0.9-5.1,2.8-7s4.2-2.8,7-2.8c2.7,0,5,0.9,7,2.8s3,4.2,3,7v2.5 H464c2.7,0,5,0.9,7,2.8c2,1.9,3,4.2,3,7c0,2.7-1,5-3,7s-4.3,3-7,3h-14.9v15c0,4.1,1.5,7.6,4.4,10.6 C456.3,220.3,459.8,221.8,464,221.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M207.1,172.3c9.9,0.2,18.2,3.7,24.8,10.4c6.6,6.7,10.1,15,10.4,24.9c-0.3,9.9-3.8,18.2-10.4,24.9 c-6.6,6.7-14.9,10.1-24.8,10.4c-10-0.2-18.3-3.7-24.9-10.4c-6.6-6.7-10.1-15-10.4-24.9c0.3-9.9,3.8-18.2,10.4-24.9 C188.8,176,197.1,172.5,207.1,172.3z M222.2,207.5c0-4.1-1.5-7.7-4.5-10.7s-6.5-4.5-10.7-4.5c-4.2,0-7.8,1.5-10.8,4.5 s-4.5,6.6-4.5,10.7c0,4.1,1.5,7.7,4.5,10.7s6.6,4.5,10.8,4.5c4.1,0,7.7-1.5,10.7-4.5S222.2,211.6,222.2,207.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M335.4,242.6c-9.7-0.2-17.9-3.6-24.6-10.2s-10.2-14.8-10.4-24.5c0.2-10.1,3.7-18.4,10.3-25 c6.6-6.6,14.7-10,24-10.3h13.8c2.8,0,5.1,1,7,2.9s2.9,4.3,2.9,7c0,2.7-1,5.1-2.9,7c-1.9,2-4.3,3-7,3h-13.1 c-4.1,0-7.7,1.5-10.7,4.4c-3,3-4.5,6.5-4.5,10.6c0,4.2,1.4,7.7,4.3,10.5c2.9,2.8,6.5,4.3,10.9,4.5h13c2.8,0,5.1,1,7,3 s2.9,4.3,2.9,7c0,2.8-1,5.1-2.9,7s-4.3,2.9-7,2.9L335.4,242.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M345.1,207.6c0,2.7-1,5-3,7s-4.3,3-7,3H320c-2.8,0-5.1-1-7-3s-2.8-4.3-2.8-7c0-2.8,0.9-5.1,2.8-7 s4.2-2.8,7-2.8h15.1c2.7,0,5,0.9,7,2.8C344.2,202.5,345.1,204.8,345.1,207.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYolorektLogoStacked3D);
export default __webpack_public_path__ + "static/media/yolorekt_logo-stacked-3D.01a079850a9223979e938886c72c5356.svg";
export { ForwardRef as ReactComponent };